import { EffectCallback, useEffect } from 'react';

export const useEffectOnUnmount = (effect: EffectCallback) => {
  useEffect(() => {
    return () => {
      effect();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
